import React, {
  FC,
} from 'react';
import { ARViewerModel } from '../model/ARViewerModel';

type ARViewerProps = {model: ARViewerModel}

export const SvgComponent:FC<ARViewerProps> = () => (
  <svg
    width={32}
    height={29}
    viewBox="0 0 32 29"
    style={{ marginRight: '10px', position: 'relative', top: '6px' }}
  >
    <defs>
      <filter colorInterpolationFilters="auto" id="prefix__a">
        <feColorMatrix
          in="SourceGraphic"
          values="0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
        />
      </filter>
    </defs>
    <g filter="url(#prefix__a)" fill="none" fillRule="evenodd">
      <g fill="#000" fillRule="nonzero">
        <path d="M13.778 0H2.222C.977 0 0 .966 0 2.197v24.606C0 28.033.977 29 2.222 29h11.556C15.023 29 16 28.034 16 26.803V2.197C16 .967 15.023 0 13.778 0zM4 .879h8v.44c0 .264-.177.439-.444.439H4.444c-.267 0-.444-.175-.444-.44v-.44zm11.111 25v.924c0 .746-.578 1.318-1.333 1.318H2.222c-.755 0-1.333-.572-1.333-1.318V2.197c0-.747.578-1.318 1.333-1.318h.89v.439c0 .747.577 1.318 1.332 1.318h7.112c.755 0 1.333-.571 1.333-1.318v-.44h.889c.755 0 1.333.572 1.333 1.319v23.682zM23 4.429L25.429 2l.571.571L23.571 5zM29 15h3v1h-3zM22 26.591l.688-.591L25 28.409l-.688.591zM25 10.474L17 6v1.03l6.529 3.668L17 14.367v1.03l7.08-3.982v9.574L17 24.972V26l8-4.474z" />
        <path d="M6 21.526L14 26v-1.028L6.92 20.99v-9.574L14 15.396v-1.03l-6.529-3.668L14 7.03V6l-8 4.474z" />
      </g>
    </g>
  </svg>
);

export const CloseBtn:FC<ARViewerProps> = () => (
  <svg
    width={14}
    height={14}
    viewBox="0 0 14 14"
    style={{ marginRight: '10px', position: 'relative', top: '6px' }}
  >
    <g id="Designs" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Home-page-Mobile-Hotspot-AR-Open" transform="translate(-316.000000, -456.000000)" fill="#000000" fillRule="nonzero">
        <path d="M324.663166,463 L329.655064,467.990768 C330.114979,468.450684 330.114979,469.195148 329.655064,469.655064 C329.195148,470.114979 328.450684,470.114979 327.990768,469.655064 L323,464.663166 L318.009232,469.655064 C317.549316,470.114979 316.804852,470.114979 316.344936,469.655064 C315.885021,469.195148 315.885021,468.450684 316.344936,467.990768 L321.336834,463 L316.344936,458.009232 C315.885021,457.549316 315.885021,456.804852 316.344936,456.344936 C316.804852,455.885021 317.549316,455.885021 318.009232,456.344936 L323,461.336834 L327.990768,456.344936 C328.450684,455.885021 329.195148,455.885021 329.655064,456.344936 C330.114979,456.804852 330.114979,457.549316 329.655064,458.009232 L324.663166,463 Z" id="Path" />
      </g>
    </g>
  </svg>
);
